import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useTranslation, useLanguage } from '../i18n';
import './NotFoundPage.css';

function NotFoundPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { lang } = useLanguage();

  return (
    <div className="not-found-page">
      <Helmet>
        <html lang={lang} />
        <meta name="robots" content="noindex, nofollow" />
        <title>{`404 - ${t('notfound_title')} | Bangkok In Home Massage`}</title>
      </Helmet>
      <div className="not-found-container">
        <h1 className="not-found-code">404</h1>
        <h2 className="not-found-title">{t('notfound_title')}</h2>
        <p className="not-found-desc">{t('notfound_desc')}</p>
        <button className="btn-primary" onClick={() => navigate('/')}>
          {t('notfound_home')}
        </button>
      </div>
    </div>
  );
}

export default NotFoundPage;
